<template>
    <div class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '圖表 & 列表'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <mdChart
                        :obj="chart"
                        :height="chartHeight"
                    ></mdChart>
                    <div class="hr"></div>
                    <gTable
                        ref="table"
                        :fixedHeader="false"
                        :table="content.table"
                        :haveSearch="content.haveSearch"
                        :havePageination="content.havePageination"
                        :setLength="content.setLength"
                        :setTitle="content.setTitle"
                        :focus="content.focus"
                        :displayToolBar="content.displayToolBar"
                        :check="content.check"
                        :download="content.download"
                        :haveBorder="content.haveBorder"

                        @sendEvent="receiveEvent"
                    ></gTable>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdChart from '@/components/mdChart'
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import gTable from '@/components/gTable'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdChart,
            mdCaption,
            mdToggleAside,
            gTable,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: { //依照模板定義
                type: Object,
                require: false
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            let _chartHeight = this.content.chartHeight,
                _chartHeightSet = null;
                

            if(  this.content.chartHeight && typeof _width === 'number' ) {
                _chartHeightSet = _chartHeight;
            }else {
                _chartHeightSet = 200;
            }

            return {
                styleSet: $styleSet,
                chartHeight: _chartHeightSet,
                chart: {}
            }
        },
        computed: {
            haveAction: function() {
                return this.content.action && typeof this.content.action === 'function';
            },
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                if( this.haveAction ) {
                    $results.push($action);
                }

                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            receiveEvent: function() {
                this.$siteTool.receiveEvent(this.content, arguments);
            },
            sendFuncEvent: function(func){ //只有 table 有可能多功能
                let $content = this.content;

                $content[func]($content.table);
            },
            action: function(){
                let $content = this.content,
                    $table = $content.table;

                let $refTable = this.$refs.table,
                    $_validate = $refTable.validate,
                    $validate = $refTable.validate(),
                    $_doAction = () => {

                        if( this.haveAction ) {
                            $content.action($table);
                        }

                        if( $content.actionStopClose !== true ) {
                            this.close();
                        }
                    }

                if( $validate.then ) {

                    $validate.then(result => {

                        if (!result){
                            //啊就沒通過啊
                        }else {
                            $_doAction();
                        }
                    });
                }else {
                    $_doAction();
                }
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        },
        created: function(){
            if( this.content.chartData ) {
                this.$set(this, 'chart', this.content.chartData);
            }
        }
    }
</script>

<style scoped lang="scss">

    .hr {
        height: 20px;
    }
</style>
